import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

export type NotificationPreferenceType = 'inAppPush' | 'browserPush';

interface NotificationPreferenceState {
  browserPushEnabled: boolean;
  inAppPushEnabled: boolean;
}

interface NotificationPreferenceActions {
  setBrowserPushEnabled: (enabled: boolean) => void;
  setInAppPushEnabled: (enabled: boolean) => void;
  updatePreference: (type: NotificationPreferenceType, enabled: boolean) => void;
}

export type NotificationPreferenceStore = NotificationPreferenceState &
  NotificationPreferenceActions;

const STORAGE_KEY = 'kc-notification-settings';
const STORE_NAME = 'NotificationPreferenceStore';

export const useNotificationPreferenceStore = create<NotificationPreferenceStore>()(
  devtools(
    persist(
      set => ({
        browserPushEnabled: false,
        inAppPushEnabled: true,

        setBrowserPushEnabled: (enabled: boolean) => {
          set({ browserPushEnabled: enabled }, undefined, `${STORE_NAME}/setBrowserPushEnabled`);
        },

        setInAppPushEnabled: (enabled: boolean) => {
          set({ inAppPushEnabled: enabled }, undefined, `${STORE_NAME}/setInAppPushEnabled`);
        },

        updatePreference: (type, enabled) => {
          set(
            type === 'browserPush'
              ? { browserPushEnabled: enabled }
              : { inAppPushEnabled: enabled },
            undefined,
            `${STORE_NAME}/update/${type}`,
          );
        },
      }),
      {
        name: STORAGE_KEY,
        partialize: state => ({
          browserPushEnabled: state.browserPushEnabled,
          inAppPushEnabled: state.inAppPushEnabled,
        }),
      },
    ),
    { name: STORE_NAME },
  ),
);
